// These are the possible values to pass in to the contentKey prop
// <EmptyState contentKey="value_goes_here" />
const CONTENT_ADMIN_DASHBOARD = 'admin_dashboard'
const CONTENT_ANALYTICS_EVENTS = 'analytics_events'
const CONTENT_ANALYTICS_MEETINGS = 'analytics_meetings'
const CONTENT_ANALYTICS_ROUTING = 'analytics_routing'
const CONTENT_CONTACTS = 'contacts'
const CONTENT_EVENT_TYPES = 'event_types'
const CONTENT_GROUPS = 'groups'
const CONTENT_MANAGED_EVENT_TYPES = 'managed_event_types'
const CONTENT_MANAGED_WORKFLOWS = 'managed_workflows'
const CONTENT_MEETINGS = 'meetings'
const CONTENT_ROUTING_FORMS = 'routing_forms'
const CONTENT_USERS = 'users'
const CONTENT_WORKFLOWS = 'workflows'
const CONTENT_SINGLE_USE_LINKS = 'single_use_links'
const CONTENT_POLLS = 'polls'
const CONTENT_RECAPS = 'recaps'
const CONTENT_RECAPS_MI_ENABLED = 'recaps_mi_enabled'
const CONTENT_SCHEDULING = 'scheduling'
const CONTENT_MEETING_TYPES = 'meeting_types'
const SAMPLE_RECAP = 'sample_recap'
const CONTENT_BLOCKED_SOURCES = 'blocked_sources'

export const CONTENT_PAGES = {
  adminDashboard: CONTENT_ADMIN_DASHBOARD,
  analyticsEvents: CONTENT_ANALYTICS_EVENTS,
  analyticsMeetings: CONTENT_ANALYTICS_MEETINGS,
  analyticsRouting: CONTENT_ANALYTICS_ROUTING,
  contacts: CONTENT_CONTACTS,
  eventTypes: CONTENT_EVENT_TYPES,
  groups: CONTENT_GROUPS,
  managedEventTypes: CONTENT_MANAGED_EVENT_TYPES,
  managedWorkflows: CONTENT_MANAGED_WORKFLOWS,
  meetings: CONTENT_MEETINGS,
  routingForms: CONTENT_ROUTING_FORMS,
  users: CONTENT_USERS,
  workflows: CONTENT_WORKFLOWS,
  singleUseLinks: CONTENT_SINGLE_USE_LINKS,
  polls: CONTENT_POLLS,
  recaps: CONTENT_RECAPS,
  sampleRecap: SAMPLE_RECAP,
  recapsMIEnabled: CONTENT_RECAPS_MI_ENABLED,
  scheduling: CONTENT_SCHEDULING,
  meetingTypes: CONTENT_MEETING_TYPES,
  blockedSources: CONTENT_BLOCKED_SOURCES,
}
